import { connect } from 'react-redux';

import {
  addToShoppingList,
  addToShoppingListFromBasket,
  closeForm,
  createShoppingList,
  createShoppingListFromBasket,
  loadAllShoppingLists,
  loadShoppingListsForSku,
  openForm,
  updateNewShoppingListField,
} from '../actions/shoppingLists';

import ShoppingListsModal from '../components/ShoppingListsModal';

export default connect((state) => ({
  addNew: state.shoppingLists.addNew,
  basket: state.basket,
  fromBasket: state.shoppingLists.fromBasket,
  items: state.shoppingLists.items,
  newShoppingList: state.shoppingLists.newShoppingList,
  pending: state.shoppingLists.pending,
  product: state.shoppingLists.product,
}), {
  addToShoppingList,
  addToShoppingListFromBasket,
  closeForm,
  createShoppingList,
  createShoppingListFromBasket,
  loadAllShoppingLists,
  loadShoppingListsForSku,
  openForm,
  updateNewShoppingListField,
})(ShoppingListsModal);
